export enum VotingType {
    addTool = "addTool",
    addQuestion = "addQuestion"
}
